import React, { useEffect, useState } from 'react';
import KoIcon from '@kwapio/icons';
import {
  KoText,
  KoModal,
  KoButton,
  KoForm,
  KoLoader,
  KoTable,
  KoPagination,
  KoNano,
  KoTitle,
  KoToast,
  KoFolderCrud,
  KoSearch,
  KoTooltips,
  // KoBadge,
  KoUpload,
  KoSelect,
  KoEmpty,
  KoBreadcrumb,
  KoDropdown,
  KoAffix
} from "packages";
import KoToolBar from "shared/components/toolbar";
import { COLUMNS_GROUPS } from "./constant";
import styles from "./drive.module.scss";
import { FilesAPI } from './files.service';
import FileShareCrud from './fileShareCrud';
import { useParams } from 'react-router';
import DocumentCreate from './documentcreate';
import { Link } from 'react-router-dom';
import { getCookie } from 'shared/utils/cookies';
import FileRenameCrud from './renameCrud';
import { downloadFile, exportSlateToDocx } from './downloaddocx';
import { findPathToFolder } from 'shared/utils';


function StarredDrive() {

  const { workspaceId } = useParams();
  const [openFileCreate, setOpenFileCreate] = useState(false);
  const [isFolderOpen, setFolderModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [activeFolder, setActiveFolder] = useState();
  const [currentRecord, setCurrentRecord] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isdeleteFile, setDeleteFileModal] = useState(false);
  const [selectedDocx, setSelectedDocx] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [, setTotalFolderCount] = useState();
  const [targetFolder, setTargetFolder] = useState();
  const [folders, setFolders] = useState();
  const [recentRequestList, setRecentRequestList] = useState();
  const [isFileShareOpen, setFileShareModal] = useState(false);
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [copy, setCopy] = useState(false);
  const [moveFileModal, setMoveFileModal] = useState(false);
  const [renameFileModal, setRenameFileModal] = useState(false);
  const [fileType, setFileType] = useState('docx');
  const [breadcrumbPath, setBreadcrumbPath] = useState();
  
  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1,
    starred:true
  });

  const [paginationFolder  ] = useState({
    size: 100,
    offset: 0,
    page: 1,
    starred:true
  });

  const [form] = KoForm.useForm();
  const [rform] = KoForm.useForm();
  const [shereform] = KoForm.useForm();

  useEffect(() => {
    getFolders(paginationFolder);
    getDocuments(pagination);
  }, []);

  useEffect(() => {
    if(activeFolder?.folderId){
      delete pagination?.['starred'];
      getDocuments(pagination, activeFolder?.folderId);
    }
    
  }, [activeFolder]);

  const getFolders = (q) => {
    setLoading(true);
    FilesAPI.getFolders(q).then(
      (data) => {
        setFolders(data['folders'] || []);
        setTotalFolderCount(data['totalCount']);
        setFolderModal(false);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getDocuments = (q, folderId) => {
    setLoading(true);
    FilesAPI.getDocuments(q, folderId).then(
      (data) => {
        setOpenFileCreate(false);
        setRecentRequestList();
        setRecentRequestList(data['files']);
        setTotalCount(data['totalCount']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page

    };
    const p = Object.assign(pagination, query);
    setPagination(p);
    getDocuments(p);
  };


  // const onCreateFolder = () => {
  //   setFolderModal(true);
  // };

  const handleFolderFinish = (values => {
    if (!currentRecord?.folderId) {
      values['folderId'] = KoNano('FOL');
    }
    FilesAPI.createOrUpdateFolder(values, currentRecord?.folderId, workspaceId).then(
      (data) => {
        getFolders();
        setFolderModal(false);
        KoToast.success(`Folder ${currentRecord?.folderId ? 'updated' : 'created'} successfully`);
      },
      (err) => {
      }
    );
  });

  const handleFileShareFinish = (values => {
    let obj={
      documentId:selectedDocx.length > 0 ? selectedDocx : [currentRecord?.documentId],
      ...values
    };
    FilesAPI.fileShare(obj).then(
      (data) => {
        getFolders();
        setFolderModal(false);
        KoToast.success(`Folder ${currentRecord?.folderId ? 'updated' : 'created'} successfully`);
      },
      (err) => {
      }
    );
  });


  const handleFinishDelete = () => {
    setLoading(true);
    FilesAPI.deleteFolderById(activeFolder?.folderId).then(
      (data) => {
        getFolders();
        setLoading(false);
        setDeleteModal(false);
        KoToast.success(`Folder deleted successfully! ${activeFolder.name}!`);
      },
      (err) => {
        KoToast.error(`error`);
        setLoading(false);
      }
    );
  };

  const handleFinishDeleteFile = () => {
    setLoading(true);
    let fids={
      documentId:selectedDocx.length > 0 ? selectedDocx : [currentRecord?.documentId]
    };
    FilesAPI.deleteDocumentById(fids).then(
      (data) => {
        getDocuments();
        setLoading(false);
        setDeleteFileModal(false);
        KoToast.success(`Document deleted successfully!`);
      },
      (err) => {
        KoToast.error(`error`);
        setLoading(false);
      }
    );
  };

  // const handleFolderAction = (folder) => {
  //   setCurrentRecord(folder);
  //   setFolderModal(true);
  // };

  const onRowSelection = (selectedRowKeys) => {
    setSelectedDocx(selectedRowKeys);
  };

  const onCopyTicket = (row) => {
    setCopy(true);
    navigator.clipboard.writeText(`${window.location.origin}/open/document/${row?.documentId}`);
  };


  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.table} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        {/* <KoTooltips title={'Comments'}>
          <KoBadge count={row?.commentsCount} >
            <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'ChatOutlined'} />} />
          </KoBadge>
        </KoTooltips> */}
        <KoTooltips title={copy ? 'Copied' : 'Copy'}>
          <KoButton onClick={() => onCopyTicket(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'CopyOutlined'} />} />
        </KoTooltips>
        <KoTooltips title={'New window'}>
          <Link target="_blank" to={`/open/document/${row?.documentId}`}>
            <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'OpenOutlined'} />} />
          </Link>
        </KoTooltips>
        <KoTooltips title={'Download'}>
          <KoButton onClick={() => row.type === 'docx' ? exportSlateToDocx(row?.url, row?.name+'.docx', setLoading) : downloadFile(row?.url, row?.name, setLoading)}
            className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DownloadOutlined'} />} />
        </KoTooltips>
      </div>;
    }
  }];

  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/file/upload/files`,
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        getDocuments();
        setUploadFileModal(false);
        KoToast.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    }
  };

  const onCellClick = (data) => {
    setCurrentRecord(data);
    if (data?.type !== 'docx') {
      setFileType(data?.type);
    }
    setOpenFileCreate(true);
  };

  const onSelectTargetFolder = (folder) => {
    setTargetFolder(folder);
  };

  const moveToFolder = () => {
    setLoading(true);
    FilesAPI.moveDocumentToFolder({documentId:selectedDocx}, targetFolder.folderId).then(
      (data) => {
        let q = pagination;
        q['folderId'] = targetFolder.folderId;
        getDocuments(q);
        setLoading(false);
        setSelectedDocx([]);
        setMoveFileModal(false);
        KoToast.success(`Document moved successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  const onExtraClick = (record, col) => {
    let fids={
      id: record.documentId || record?.folderId,
      isStarred: !record.isStarred,
      name:col ? col :'file'
    };
    setLoading(true);
    FilesAPI.starredDocument(fids).then(
      (data) => {
        setLoading(false);
        getFolders(paginationFolder);
        getDocuments(pagination);
        KoToast.success(`Document starred successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };


  const onSearchText = (text) => {
    let q = pagination;
    q['search'] = text;
    getDocuments(q);
  };

  const onSearchTextFolder = (text) => {
    let q = paginationFolder;
    q['search'] = text;
    getFolders(q);
  };

  const getFolderPath = (folder) => {
    getDocuments(pagination, folder?.folderId);
    if (!folder.parentFolderId) {
      setBreadcrumbPath([folder]);
      setActiveFolder(folder);
      return;
    }
    const fullPath = findPathToFolder(folders, folder.folderId);
    if (fullPath) {
      setBreadcrumbPath(fullPath);
      setActiveFolder(folder);
    } else {
      console.warn('Folder path not found in structure');
    }
  };
  

  const handleFinishRenameFile = (values) => {
    setLoading(true);

    FilesAPI.renameDocument(values, currentRecord.documentId).then(
      (data) => {
        let q = pagination;
        // q['folderId'] = act' iveFolder?.folderId;
        getDocuments(q);
        setLoading(false);
        setRenameFileModal(false);
        KoToast.success(`Document renamed successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  const getinistallData=()=>{
    let pf={
      size: 100,
      offset: 0,
      page: 1
    };
    let pd={
      size: 10,
      offset: 0,
      page: 1
    };
    setActiveFolder();
    getFolders(pf);
    setBreadcrumbPath();
    getDocuments(pd);
  };

  let breadcrumb = [{
    title: <KoText className={`${!activeFolder?.name ? styles.dark : styles.lite}`} text="Recently Starred" />,
    onClick: () => getinistallData()
  }];
  
  if (activeFolder?.name) {
    breadcrumb.push({
      title: <KoText className={`${styles.dark}`} text={activeFolder.name} />
    });
  }


  return (
    <div className={styles.container}>
      {isLoading && <KoLoader />}
      <div className={styles.wrapper}>
        <KoAffix top={50}>
          <div className={styles.headerWrapper}>
            <div className={styles.breadWrapper}>
              <KoTitle onClick={() => getinistallData()} className={`${styles.dark}`} level={4} text={`Starred`} />
              {breadcrumbPath?.length > 0 && <KoIcon name="ArrowRightOutlined" />}
              <KoBreadcrumb
                className={styles.breadWrapper}
                separator={<KoIcon name="ArrowRightOutlined" />}
                items={breadcrumbPath?.map(folder => ({
                  title: (
                    <KoText
                      className={`${!folder?.name ? styles.dark : styles.lite}`}
                      text={folder?.name}
                    />
                  ),
                  onClick: () => getFolderPath(folder)
                }))}
              />
            </div>
            <div className={styles.searchWrapper}>
              <KoSearch placeholder="Type to search folders / files"  onChange={(e) => onSearchTextFolder(e.target.value)}/>
            </div>
         
          </div>
        </KoAffix>
        { !activeFolder &&  <div className={styles.ulCreate}>
          {folders?.map((folder, i) => (<div key={i} className={styles.li} >
            <div className={styles.headerCreate} onClick={() => { setActiveFolder(folder); getFolderPath(folder); }}>
              <KoButton className={`${styles.btnmedium}`} color="default" variant="filled" icon={<KoIcon color="#FFF" width={23} height={23} name="FolderLine" />} />
              <div>
                <KoText className={styles.title} text={folder?.name} />
                <div className={styles.folderChild}>
                  {folder?.children?.length > 0 &&
                  <KoText className={styles.fileCount} ellipsis={true} text={`${folder?.folderCount} ${(folder?.folderCount === 1 || folder?.folderCount === 0) ? 'Folder' : 'Folders'}`} />}
                  <KoText className={styles.fileCount} ellipsis={true} text={`${folder?.fileCount} ${(folder?.fileCount === 1 || folder?.fileCount === 0) ? 'File' : 'Files'}`} />
                </div>
              </div>
            </div>
            {/* {folder?.description && <div className={styles.content}>
              <KoText className={styles.description} ellipsis={true} text={folder?.description} />
            </div>} */}
            <KoDropdown
              overlayClassName={styles.settings}
              popupRender={(menu) => (
                <div className={styles.customDropdown} >
                  <div className={styles.customDropdownContnet}>
                    <ul>
                      <li onClick={() => onExtraClick && onExtraClick(folder, 'folder')}>
                        <KoIcon name={'StarOutlined'} color={folder?.isStarred ? 'var(--query)' : ''} />
                        <KoText text={folder?.isStarred ? 'unstar' : 'Star'} />
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              placement={'bottomRight'}>
              <KoButton  type='text' icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />} className={`${styles.btn} smallBtn`} />
            </KoDropdown>
          </div>))}
        </div>}
        {
          folders?.length === 0 && <div className={styles.empty}>
            <KoEmpty title="No Shared Folder found" subTyext='There are no shared folders available.' />
          </div>
        }
        {activeFolder?.children?.length > 0 &&
        <div className={styles.ulCreate}>
          { activeFolder?.children?.map((folder, i) => (<div key={i} className={styles.li} onClick={() => { setActiveFolder(folder); getFolderPath(folder); }}>
            <div className={styles.headerCreate}>
              <KoButton className={`${styles.btnmedium}`} color="default" variant="filled" icon={<KoIcon color="#FFF" width={15} height={15} name="FolderLine" />} />
              <div>
                <KoText className={styles.title} text={folder?.name} />
                <div className={styles.folderChild}>
                  {folder?.children?.length > 0 && <KoText className={styles.fileCount} ellipsis={true} text={`${folder?.children?.length > 0 ? folder?.children?.length : 0} ${(folder?.children?.length === 1 || folder?.children?.length === 0) ? 'Folder' : 'Folders'}`} />}
                  <KoText className={styles.fileCount} ellipsis={true} text={`${folder?.fileCount} ${(folder?.fileCount === 1 || folder?.fileCount === 0) ? 'File' : 'Files'}`} />
                </div>
              </div>
            </div>
            {/* <div className={styles.content}>
              {folder?.description && <KoText className={styles.description} ellipsis={true} text={folder?.description} />}
            </div> */}
            <KoDropdown
              overlayClassName={styles.settings}
              popupRender={(menu) => (
                <div className={styles.customDropdown} >
                  <div className={styles.customDropdownContnet}>
                    <ul>
                      <li onClick={() => onExtraClick && onExtraClick(folder, 'folder')}>
                        <KoIcon name={'StarOutlined'} color={folder?.isStarred ? 'var(--query)' : ''} />
                        <KoText text={folder?.isStarred ? 'unstar' : 'Star'} />
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              placement={'bottomRight'}>
              <KoButton type='text' icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />} className={`${styles.btn} smallBtn`} />
            </KoDropdown>
          </div>))}
        </div>}
        <div className={`${styles.tableWrapper} tableCard`}>
          <KoToolBar
            title={ <KoBreadcrumb
              className={styles.breadWrapper}
              separator={<KoIcon name="ArrowRightOutlined" />}
              items={breadcrumb}
            />}
            search={{ visible: true, onChange: onSearchText,  placeholder: 'Search by any parameter' }}
            filter={{
              visible: false,
              options: [{ label: 'Sort By Name', key: '0' },
                { label: 'Created At', key: '2' },
                { label: 'Sort By designation', key: '3' }]
            }}
            buttonList={[]} />

          <KoTable rowKey={'documentId'} data={{ columns: COLUMNS_GROUPS, rows: recentRequestList }}
            onRowSelection={onRowSelection}
            onCellClick={onCellClick}
            onExtraClick={onExtraClick}
            extraColumnsRight={columnsRight} maxHeight={79} />
          <KoPagination current={parseInt(pagination.page) || 1}
            total={totalCount}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
            }
            pageSize={pagination.limit}
            defaultCurrent={pagination.page}
            onChange={onPagination}
            showQuickJumper={false}
            simple={false}
            responsive={false} />
        </div>

        {openFileCreate && <DocumentCreate
          openFileCreate={openFileCreate}
          showComments={true}
          setOpenFileCreate={setOpenFileCreate}
          getDocuments={getDocuments}
          type={fileType}
          documentId={currentRecord?.documentId} />}

        <KoModal
          title={currentRecord?.folderId ? `Update Folder ${currentRecord?.name?.toUpperCase()}` : 'Create Folder'}
          centered
          open={isFolderOpen}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setFolderModal(false); }}
          onClose={() => { setCurrentRecord(); setFolderModal(false); }}
          width={680}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setFolderModal(!isFolderOpen)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={`${currentRecord?.folderId ? 'Update' : 'Create'}`} onClick={() => form.submit()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <KoFolderCrud form={form} handleFinish={handleFolderFinish} initialValues={currentRecord} />
        </KoModal>

        <KoModal
          title={`Delete folder ${activeFolder?.name?.toUpperCase()}`}
          centered
          open={isOpenDelete}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
          onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
            <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDelete()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.delWrapper}>
            <KoTitle level={5} text={`Are you sure you want to delete this folder?`} />
            <KoText text={`This action is irreversible, and it will result in the removal of their associated data and Kwapio license.`} />
          </div>
        </KoModal>

        <KoModal
          title={`Delete document ${currentRecord?.name ? currentRecord?.name?.toUpperCase() : ''}`}
          centered
          open={isdeleteFile}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setDeleteFileModal(false); }}
          onClose={() => { setCurrentRecord(); setDeleteFileModal(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setDeleteFileModal(false)} />,
            <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDeleteFile()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.delWrapper}>
            <KoTitle level={5} text={`Are you sure you want to delete this document?`} />
            <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
          </div>
        </KoModal>

        <KoModal
          title={'Manage File Sharing'}
          centered
          open={isFileShareOpen}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setFileShareModal(false); }}
          onClose={() => { setCurrentRecord(); setFileShareModal(false); }}
          width={760}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setFileShareModal(!isFileShareOpen)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={'Share'} onClick={() => shereform.submit()} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <FileShareCrud form={shereform} initialValues={currentRecord} handleFinish={handleFileShareFinish} />
        </KoModal>

        <KoModal
          title={'Upload File'}
          centered
          open={uploadFileModal}
          handleOk={() => { setUploadFileModal(false); }}
          onClose={() => { setUploadFileModal(false); }}
          width={760}
          footer={[]}
        >
          <div className={`${styles.uploadWrapper} customUpload`}>
            {isLoading && <KoLoader circle={false} />}
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </div>
        </KoModal>

        <KoModal
          title={'Move to Folder'}
          centered
          open={moveFileModal}
          handleOk={() => { setMoveFileModal(false); }}
          onClose={() => { setMoveFileModal(false); }}
          width={550}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setMoveFileModal(false)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={'Move'} onClick={() => moveToFolder()} />
          ]}
        >
          <div className={`${styles.uploadWrapper}`}>
            {isLoading && <KoLoader circle={false} />}
            <KoText text={`Select a folder to move the file(s) to. (${selectedDocx.length} selected)`} />
            <label>&nbsp;</label>
            <KoSelect
              placeholder="Select module"
              onChange={v => onSelectTargetFolder(v)}
              options={folders?.map((fs) => ({
                label: fs?.name,
                value: fs?.folderId
              }))}
            />
          </div>
        </KoModal>

        <KoModal
          title={'Rename File'}
          centered
          open={renameFileModal}
          handleOk={() => { setRenameFileModal(false); }}
          onClose={() => { setRenameFileModal(false); }}
          width={550}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setRenameFileModal(false)} />,
            <KoButton key='create' loading={isLoading} type='primary' label={'Rename'} onClick={() => rform.submit()} />
          ]}
        >
          <div className={`${styles.uploadWrapper}`}>
            {isLoading && <KoLoader circle={false} />}
            <FileRenameCrud form={rform} initialValues={currentRecord} handleFinish={handleFinishRenameFile} />
          </div>
        </KoModal>

        

      </div>
    </div>
  );
}

export default StarredDrive;